import {
  useMutation,
  useQueryClient,
  type UseMutationResult,
} from '@tanstack/react-query';
import type {
  BillingResumeSubscriptionRequest,
  BillingResumeSubscriptionResponse,
} from '@kawai/shared';
import { callBillingResumeSubscription } from '../api/billingResumeSubscription.js';

/**
 * TP-23: `billingResumeSubscription` Callable を呼ぶ React Query mutation hook。
 *
 * 成功時は `['tenants']` と `['billing_subscriptions']` を invalidate し、稼働中バッジ /
 * 解約ボタン活性を即時反映する。
 */
export function useBillingResumeSubscription(): UseMutationResult<
  BillingResumeSubscriptionResponse,
  Error,
  BillingResumeSubscriptionRequest
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: BillingResumeSubscriptionRequest) =>
      callBillingResumeSubscription(input),
    onSuccess: async () => {
      // 互いに無関係な refetch を並列化（直列 await は不要 / レビュー指摘）。
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['tenants'] }),
        queryClient.invalidateQueries({ queryKey: ['billing_subscriptions'] }),
      ]);
    },
  });
}
